import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', path: '/' },
      { label: '分类浏览', path: '/category' },
      { label: '关于我们', path: '/about' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { label: '个人资料', path: '/category?tab=profile' },
      { label: '出道经历', path: '/category?tab=debut' },
      { label: '代表作品', path: '/category?tab=works' },
      { label: '写真集', path: '/category?tab=photo' },
    ],
  },
  {
    title: '更多资源',
    links: [
      { label: '最新动态', path: '/category?tab=news' },
      { label: '访谈记录', path: '/category?tab=interview' },
      { label: '粉丝社区', path: '/category?tab=community' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-semibold tracking-wide">
                佐山爱
              </span>
              <span className="block text-xs text-secondary-400 font-body mt-1">
                官方资料站
              </span>
            </Link>
            <p className="text-sm text-secondary-400 leading-relaxed">
              汇聚最权威、最完整的佐山爱相关信息，
              带你深入认识这位备受关注的日本女艺人。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold mb-4 text-background-50/90">
                {group.title}
              </h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-secondary-400 hover:text-background-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; {new Date().getFullYear()} 佐山爱官方资料站. 本站为粉丝自发建立的资讯平台，非官方授权站点。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-secondary-500 hover:text-background-50 transition-colors cursor-pointer"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-secondary-500 hover:text-background-50 transition-colors cursor-pointer"
              rel="nofollow"
            >
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}